"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainWebShop = exports.ABTestContextAwareConfigurationValue = exports.AemConfigurationThirdpartySocialLoginProvider = void 0;
var AemConfigurationThirdpartySocialLoginProvider;
(function (AemConfigurationThirdpartySocialLoginProvider) {
    AemConfigurationThirdpartySocialLoginProvider["FACEBOOK"] = "facebook";
})(AemConfigurationThirdpartySocialLoginProvider || (exports.AemConfigurationThirdpartySocialLoginProvider = AemConfigurationThirdpartySocialLoginProvider = {}));
var ABTestContextAwareConfigurationValue;
(function (ABTestContextAwareConfigurationValue) {
    ABTestContextAwareConfigurationValue["ENABLED"] = "enabled";
    ABTestContextAwareConfigurationValue["ENABLED_WITH_AB_TEST"] = "enabled-with-ab-test";
    ABTestContextAwareConfigurationValue["DISABLED"] = "disabled";
})(ABTestContextAwareConfigurationValue || (exports.ABTestContextAwareConfigurationValue = ABTestContextAwareConfigurationValue = {}));
var MainWebShop;
(function (MainWebShop) {
    MainWebShop["ASADVENTURE"] = "asadventure";
    MainWebShop["AYACUCHO"] = "ayacucho";
    MainWebShop["BEVER"] = "bever";
    MainWebShop["COTSWOLD"] = "cotswold";
    MainWebShop["JUTTU"] = "juttu";
    MainWebShop["RUNNERSNEED"] = "runnersneed";
    MainWebShop["SNOWANDROCK"] = "snowandrock";
})(MainWebShop || (exports.MainWebShop = MainWebShop = {}));
//# sourceMappingURL=AemConfigurationTypes.js.map